export default {
  'zh-CN': {
    news:{
      NewsLetters:'企业资讯',
      RecentActivities:'最新活动',
      CompanyNews:'公司资讯',
      //  企业咨询
      Title01:'福州招商大会',
      Cintent01:'Bay福建跨境电商生态峰会暨厂商对接大会，在福州召开。聚焦科技，海纳资源，让跨境电商便捷、非凡。',
      Title02:'SpeedPAK物流管理方案正式上线！',
      Cintent02:'SpeedPAK包裹服务是eBay联合物流战略合作伙伴橙联股份有限公司共同打造，以eBay平台物流政策为基础，为eBay大中华区跨境出口电商卖家量身定制的直发物流解决方案。',
      Title03:'刚刚，eBay与中信产业基金正式签约，携手打造跨境电商物流体系！',
      Cintent03:'eBay与中信产业基金正式签约，携手打造跨境电商物流体系。众多重量级嘉宾参与并发表讲话。'
    }
  },
  'en-US':{
    news:{
      NewsLetters:'Newsletters',
      RecentActivities:'Recent Activities',
      CompanyNews:'Company News',
    //  企业咨询
      Title01:'Fuzhou Global E-commerce Summit',
      Cintent01:'ebay’s global e-commerce summit in Fuzhou has brought attentions from around the country. To ensure the future of global e-commerce to be more efficient…',
      Title02:'SpeedPAK is Officially Launched',
      Cintent02:'SpeedPAK service is brought to you by ebay and Orange Connex(China) Limited,. Developed on the foundation of ebay’s platform policy, then customized to provide direct mail service to e-commerce businesses in the great China region.',
      Title03:'Just Now! CITI CPE and ebay Kicked Off their New Era in Global E-commerce Industry.',
      Cintent03:'CITI CPE and ebay have launched their brand new masterpiece, a joint venture. Shocking the global market place with speeches from industry tycoons.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/News_local.js